import React from 'react';
import PropTypes from 'prop-types';
import date from '../../helpers/date';
import { textOrDash } from './CustomerReviewCreate.helpers';
import styles from './CustomerReviewCreate.module.css';

const OrderCard = ({ order }) => {
  const user = order.user;
  const saleProduct = order.sale_product;
  const size = saleProduct && saleProduct.size;
  const buyerText = `${textOrDash(user && user.username)} · ${textOrDash(user && user.email)}`;
  const productText = `${textOrDash(saleProduct && saleProduct.display_name)} · ${textOrDash(saleProduct && saleProduct.SKU)} · US ${textOrDash(size && size.US)}`;
  const receivedText = date(order.customer_received).format('D MMM YYYY');

  return (
    <section className={styles.orderCard} aria-live="polite">
      <div className={styles.orderFound}>ORDER FOUND</div>
      <div className={styles.orderRow}>
        <span className={styles.orderLabel}>Buyer</span>
        <span>{buyerText}</span>
      </div>
      <div className={styles.orderRow}>
        <span className={styles.orderLabel}>Product</span>
        <span>{productText}</span>
      </div>
      <div className={styles.orderRow}>
        <span className={styles.orderLabel}>Status</span>
        <span>Completed · received {receivedText}</span>
      </div>
    </section>
  );
};

OrderCard.propTypes = {
  order: PropTypes.shape({
    customer_received: PropTypes.string.isRequired,
    sale_product: PropTypes.object,
    user: PropTypes.object,
  }).isRequired,
};

export default OrderCard;
